/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_Item_BodyInputs */

const en_us2_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight and body fat`)
};

const pt_br2_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso e percentual de gordura`)
};

const es_419_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso y grasa corporal`)
};

const pt_pt2_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso e percentagem de gordura`)
};

const fr_fr2_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids et masse grasse`)
};

const de_de2_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht und Körperfett`)
};

const it_it2_profile_editors_export_item_body = /** @type {(inputs: Profile_Editors_Export_Item_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso e grasso corporeo`)
};

/**
* | output |
* | --- |
* | "Weight and body fat" |
*
* @param {Profile_Editors_Export_Item_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_item_body = /** @type {((inputs?: Profile_Editors_Export_Item_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_Item_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_item_body(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_item_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_item_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_item_body(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_item_body(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_item_body(inputs)
	return en_us2_profile_editors_export_item_body(inputs)
});
export { profile_editors_export_item_body as "profile-editors.export_item_body" }